import React, { useState } from "react";
import { useForm } from "react-hook-form";
import auth from "../../firebase.init";
import {
    useCreateUserWithEmailAndPassword,
    useUpdateProfile,
    useSendEmailVerification,
} from "react-firebase-hooks/auth";
import "./Register.css";
import registerImg from "../../imgages/register.png";
import { useNavigate, Link } from "react-router-dom";
import useToken from "../../hooks/useToken";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { strict } from "assert";

const Register = () => {
    const {
        register,
        formState: { errors },
        handleSubmit,
        reset,
    }: any = useForm();
    const [updateProfile, updating, updateerror] = useUpdateProfile(auth);

    const [sendEmailVerification] = useSendEmailVerification(auth);

    const navigate = useNavigate();
    const [createUserWithEmailAndPassword, user, loading, error] =
        useCreateUserWithEmailAndPassword(auth);

    const [token] = useToken(user);

    if (token) {
        navigate("/");
    }
    const onSubmit = async (data: any) => {
        await createUserWithEmailAndPassword(data.email, data.password);
        await updateProfile({ displayName: data.name });
        await sendEmailVerification();
        alert("Sent email");
        const userData = {
            email: data.email,
            name: data.name,
        };
        fetch("https://taskla-server-hr.onrender.com/user", {
            method: "POST",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(userData),
        })
            .then((res) => res.json())
            .then((data) => data);
        reset();
    };
    // password show/hide
    const [show, setShow] = useState<string | boolean>(false);

    const btnValue = (): void => {
        setShow((click) => !click);
    };
    return (
        <div className="relative">
            <div className='w-[1000px] lg:block hidden h-[800px] opacity-[.3]  rounded-full bg-[#9daaf6b7] absolute -right-[38%] top-[-60px]'></div>

            <div className='w-[900px] lg:block hidden h-[720px] opacity-[.3]  rounded-full bg-[#9daaf6da] absolute -right-[38%] top-[-30px]'></div>

            <div className='w-[800px] lg:block hidden h-[600px] opacity-[.3]  rounded-full bg-[#9daaf6da] absolute -right-[39%] top-[10px]'></div>

            <div className='w-[50px] h-[50px] opacity-20  rounded-full bg-purple-500 absolute top-[50px] left-[120px] z-0'></div>
            <div className='w-[100px] h-[100px] hidden lg:block  rounded-full bg-[#FBDCE9] absolute top-[40%] left-[40px] z-0'></div>
            <div className="mt-32 lg:flex justify-between items-center sm:px-48">
                <div className="">
                    <img src='https://i.ibb.co/2SRXfdP/register.png' alt="" />
                </div>
                <div className="lg:order-first">
                    <div className="w-96 p-10 mx-auto">
                        <h1 className="text-center font-bold text-3xl my-4 text-[#7586e7] dark:text-slate-200">Sign Up</h1>
                        <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>
                            <input
                                required
                                type="text"
                                placeholder="Your Name"
                                className="my-2 p-3 text-[17px] rounded-lg bg-white dark:bg-[#182233] dark:text-slate-200 w-full inline border-b-2 hover:border-b-[#7586e7] focus:outline-none transition-all duration-1000 shadow-lg"
                                {...register("name", {
                                    required: {
                                        value: true,
                                        message: "Name is required",
                                    },
                                })}
                            />
                            <label className="label">
                                {errors.name?.type === "required" && (
                                    <span className="label-text-alt text-red-500">
                                        {" "}
                                        {errors.name.message}
                                    </span>
                                )}
                            </label>
                            <input
                                className="my-2 p-3 text-[17px] rounded-lg bg-white dark:bg-[#182233] dark:text-slate-200 w-full inline border-b-2 hover:border-b-[#7586e7] focus:outline-none transition-all duration-1000 shadow-lg"
                                type="email"
                                placeholder="Your Email"
                                {...register("email", {
                                    required: {
                                        value: true,
                                        message: "Email is Required",
                                    },
                                    pattern: {
                                        value: /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/,
                                        message: "Please Provide A Valid Email",
                                    },
                                })}
                            />
                            {errors.email?.type === "required" && (
                                <p className=""> {errors.email?.message}</p>
                            )}
                            {errors.email?.type === "pattern" && (
                                <p className=""> {errors.email?.message}</p>
                            )}

                            <div className="flex">
                                <input
                                    className="my-2 p-3 text-[17px] rounded-lg bg-white dark:bg-[#182233] dark:text-slate-200 w-full inline border-b-2 hover:border-b-[#7586e7] focus:outline-none transition-all duration-1000 shadow-lg"
                                    placeholder="Password"
                                    type={show ? "text" : "password"}
                                    {...register("password", {
                                        required: {
                                            value: true,
                                            message: "Password is Required",
                                        },
                                        minLength: {
                                            value: 6,
                                            message:
                                                "Of course, you have to give a password greater than 6 digits",
                                        },
                                    })}
                                />
                                <button
                                    onClick={btnValue}
                                    className="inline text-[18px] p-[10px] ml-[-35px]  text-white"
                                >
                                    {show ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                                </button>
                            </div>
                            {errors.password?.type === "required" && (
                                <p className=""> {errors.password?.message}</p>
                            )}

                            {errors.password?.type === "minLength" && (
                                <p className=""> {errors.password?.message}</p>
                            )}

                            <input
                                className="my-2 py-3 rounded-lg text-[17px] text-white font-semibold cursor-pointer bg-[#7e8de2]"
                                value="Sign Up"
                                type="submit"
                            />
                        </form>

                        <p className="my-3 dark:text-white text-xs">
                            {" "}
                            Already Have an Account?? <Link to="/login"> Please Login</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;